/* ============================================
   HAIR TEST LAB - App JS
   Nav, Animations, Accordions, Testimonials
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  // --- Sticky Header ---
  const header = document.querySelector('.header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // --- Mobile Nav Toggle ---
  const toggle = document.querySelector('.header__toggle');
  const nav = document.querySelector('.header__nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      toggle.classList.toggle('open');
      nav.classList.toggle('open');
      document.body.style.overflow = nav.classList.contains('open') ? 'hidden' : '';
    });
    // Close on link click
    nav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        if (link.classList.contains('nav-dropdown__toggle')) return;
        toggle.classList.remove('open');
        nav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // --- Mobile Dropdown Toggle ---
  document.querySelectorAll('.nav-dropdown__toggle').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const dropdown = btn.closest('.nav-dropdown');
      dropdown.classList.toggle('open');
    });
  });

  // --- Scroll Reveal ---
  const reveals = document.querySelectorAll('.reveal, .stagger');
  if (reveals.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    reveals.forEach(el => observer.observe(el));
  }

  // --- Accordions ---
  document.querySelectorAll('.accordion-header').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.accordion-item');
      const body = item.querySelector('.accordion-body');
      const isOpen = item.classList.contains('open');

      // Close all siblings
      item.parentElement.querySelectorAll('.accordion-item.open').forEach(openItem => {
        if (openItem !== item) {
          openItem.classList.remove('open');
          openItem.querySelector('.accordion-body').style.maxHeight = '0';
        }
      });

      // Toggle current
      item.classList.toggle('open', !isOpen);
      body.style.maxHeight = isOpen ? '0' : body.scrollHeight + 'px';
    });
  });


  // --- Tabs ---
  document.querySelectorAll('.tabs__tab').forEach(tab => {
    tab.addEventListener('click', () => {
      const parent = tab.closest('.tabs');
      const target = tab.dataset.tab;

      parent.querySelectorAll('.tabs__tab').forEach(t => t.classList.remove('active'));
      parent.querySelectorAll('.tabs__panel').forEach(p => p.classList.remove('active'));

      tab.classList.add('active');
      parent.querySelector(`[data-panel="${target}"]`).classList.add('active');
    });
  });

  // --- Variant Selectors ---
  document.querySelectorAll('.variant-options').forEach(group => {
    group.querySelectorAll('.variant-option').forEach(opt => {
      opt.addEventListener('click', () => {
        group.querySelectorAll('.variant-option').forEach(o => o.classList.remove('selected'));
        opt.classList.add('selected');

        const container = opt.closest('.product-detail__info, .product-card');

        // Update price display if data-price exists
        const priceEl = container?.querySelector('.product-detail__price, .product-card__price .amount');
        if (priceEl && opt.dataset.price) {
          priceEl.textContent = HTLCart.formatPrice(opt.dataset.price);
        }

        // Update unit price
        const unitPriceEl = container?.querySelector('.product-detail__unit-price');
        if (unitPriceEl && opt.dataset.unitPrice) {
          unitPriceEl.textContent = HTLCart.formatPrice(opt.dataset.unitPrice) + ' / L';
        }

        // Update sticky bar price
        const stickyPrice = document.querySelector('.sticky-atc__price');
        if (stickyPrice && opt.dataset.price) {
          stickyPrice.textContent = HTLCart.formatPrice(opt.dataset.price);
        }
      });
    });
  });

  // --- Add to Cart Buttons ---
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const form = btn.closest('form');
      const el = btn.closest('[data-product]') || btn;
      const variantEl = el.querySelector('.variant-option.selected');
      const qtyInput = el.querySelector('.quantity-selector input');

      var variantId = btn.dataset.variantId
        || (variantEl && variantEl.dataset.variantId)
        || (form && form.querySelector('input[name="id"]') && form.querySelector('input[name="id"]').value)
        || el.dataset.variantId;

      if (!variantId) return;

      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      HTLCart.addItem(variantId, qty);
    });
  });

  // --- Product Detail Form (AJAX intercept) ---
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantInput = productForm.querySelector('input[name="id"]');
      var qtyInput = productForm.querySelector('input[name="quantity"]');
      if (!variantInput || !variantInput.value) return;
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      HTLCart.addItem(variantInput.value, qty);
    });
  }

  // --- Quantity Buttons ---
  document.querySelectorAll('.quantity-selector').forEach(sel => {
    const input = sel.querySelector('input');
    sel.querySelector('.qty-minus')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value) - 1);
      input.dispatchEvent(new Event('change'));
    });
    sel.querySelector('.qty-plus')?.addEventListener('click', () => {
      input.value = parseInt(input.value) + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  // --- Notify Modal ---
  const modal = document.querySelector('.notify-modal');
  if (modal) {
    document.querySelectorAll('[data-notify]').forEach(btn => {
      btn.addEventListener('click', () => {
        modal.querySelector('.notify-product-name').textContent = btn.dataset.productName || 'this product';
        modal.classList.add('open');
      });
    });

    modal.querySelector('.notify-modal__close')?.addEventListener('click', () => {
      modal.classList.remove('open');
    });

    modal.addEventListener('click', (e) => {
      if (e.target === modal) modal.classList.remove('open');
    });

    modal.querySelector('.notify-form')?.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = modal.querySelector('input[type="email"]').value;
      if (email) {
        HTLCart.showToast("We'll notify you when it's back in stock!");
        modal.classList.remove('open');
        modal.querySelector('input[type="email"]').value = '';
      }
    });
  }

  // --- Product Filter ---
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const filter = btn.dataset.filter;
      const parent = btn.closest('.section, main');

      btn.parentElement.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      parent.querySelectorAll('.product-card').forEach(card => {
        const cat = card.dataset.category;
        const show = filter === 'all' || cat === filter;
        card.style.display = show ? '' : 'none';
      });

      // Also hide/show category intro sections and related CTAs
      parent.querySelectorAll('[data-category-intro]').forEach(intro => {
        const cat = intro.dataset.categoryIntro;
        const show = filter === 'all' || cat === filter;
        intro.style.display = show ? '' : 'none';
      });
      parent.querySelectorAll('[data-category-cta]').forEach(cta => {
        const cat = cta.dataset.categoryCta;
        const show = filter === 'all' || cat === filter;
        cta.style.display = show ? '' : 'none';
      });
    });
  });

  // --- Video Showcase ---
  const video = document.getElementById('showcase-video');
  const muteBtn = document.getElementById('video-mute-btn');
  const fullscreenBtn = document.getElementById('video-fullscreen-btn');
  const overlay = document.getElementById('video-overlay');

  if (video && muteBtn) {
    const iconMuted = muteBtn.querySelector('.icon-muted');
    const iconUnmuted = muteBtn.querySelector('.icon-unmuted');

    // Mute/unmute toggle
    muteBtn.addEventListener('click', () => {
      video.muted = !video.muted;
      iconMuted.style.display = video.muted ? '' : 'none';
      iconUnmuted.style.display = video.muted ? 'none' : '';
    });

    // Fullscreen with landscape lock on mobile
    if (fullscreenBtn) {
      fullscreenBtn.addEventListener('click', async () => {
        if (document.fullscreenElement) {
          document.exitFullscreen();
          // Unlock orientation when exiting
          if (screen.orientation && screen.orientation.unlock) {
            screen.orientation.unlock();
          }
        } else {
          // Use the video element directly for better mobile support
          try {
            if (video.requestFullscreen) {
              await video.requestFullscreen();
            } else if (video.webkitEnterFullscreen) {
              video.webkitEnterFullscreen();
            } else if (video.webkitRequestFullscreen) {
              await video.webkitRequestFullscreen();
            }
            // Lock to landscape on mobile
            if (screen.orientation && screen.orientation.lock) {
              try { await screen.orientation.lock('landscape'); } catch(e) { /* not supported */ }
            }
          } catch(e) {
            // Fallback: try wrapper
            const wrapper = video.closest('.video-showcase__wrapper');
            if (wrapper.requestFullscreen) wrapper.requestFullscreen();
          }
        }
      });

      // Unlock orientation when user exits fullscreen
      document.addEventListener('fullscreenchange', () => {
        if (!document.fullscreenElement && screen.orientation && screen.orientation.unlock) {
          screen.orientation.unlock();
        }
      });
    }

    // Play overlay (if autoplay is blocked)
    if (overlay) {
      overlay.addEventListener('click', () => {
        video.play();
        overlay.classList.add('hidden');
      });
      // Hide overlay once video starts playing
      video.addEventListener('playing', () => {
        overlay.classList.add('hidden');
      });
    }
  }

  // --- Smooth scroll for anchor links ---
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // --- Sticky Mobile Add to Cart ---
  const stickyATC = document.getElementById('stickyATC');
  const mainATC = document.querySelector('.add-to-cart-row');
  if (stickyATC && mainATC) {
    const stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        stickyATC.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px' });
    stickyObserver.observe(mainATC);

    // Sticky bar add-to-cart delegates to the main button
    stickyATC.querySelector('[data-add-to-cart]')?.addEventListener('click', () => {
      document.querySelector('.product-detail__info [data-add-to-cart]')?.click();
    });
  }

});
